import { isClient } from "./client";
import { retry } from "./retry";

// DIGITAL DATA
export interface IDigitalData {
  page: {
    pageInfo: IDigitalDataPageInfo;
  }
}
export interface IDigitalDataPageInfo {
  pageName: string;
  livello1: string;
  secondolivello: string;
  terzolivello: string;
  quartolivello: string;
  pagetemplate: string;
}

type TrackPayload = [string, Record<string, string | number | boolean>?];

declare global {
  interface Window {
    _satellite: {
      track: (...params: TrackPayload) => void;
    };
    __satelliteLoaded: boolean;
  }
}

export const analyticsClient = {
  track: (...params: TrackPayload) => {
    retry({
      times: 5,
      every: 3000,
      condition: () => window.__satelliteLoaded,
      operation: () => window._satellite.track(...params),
    });
  },
};

export const setDigitalData = (newValues: { targetKey: keyof IDigitalDataPageInfo, value: string }[]) => {
  if(isClient()){
    const pageInfo: IDigitalDataPageInfo = (window as any).digitalData ? (window as any).digitalData.page.pageInfo : {};
    newValues.forEach(({ targetKey, value }) => pageInfo[targetKey] = value);
  }
};

